/** Normalize grid filter values to a non-empty string list for API (expects list on server). */
function toFilterStringList(value) {
    if (value === undefined || value === null)
        return undefined;
    const arr = Array.isArray(value) ? value : [value];
    const trimmed = arr
        .map((s) => String(s).trim())
        .filter((s) => s.length > 0);
    return trimmed.length > 0 ? trimmed : undefined;
}
/**
 * Maps grid filter state to {@link NodesFilters} for get-all-nodes / nodes-by-AP APIs.
 * Uses `isActive` (bool) for status — matches backend binding; Active/Inactive is derived from grid "status".
 */
export function cleanNodesFiltersForApi(gridFilters) {
    const apiFilters = {};
    const nodeNameList = toFilterStringList(gridFilters.nodeName);
    if (nodeNameList) {
        apiFilters.nodeName = nodeNameList;
    }
    const nodeUidList = toFilterStringList(gridFilters.nodeUid);
    if (nodeUidList) {
        apiFilters.nodeUid = nodeUidList;
    }
    if (gridFilters.status) {
        if (Array.isArray(gridFilters.status) && gridFilters.status.length > 0) {
            const statusValues = gridFilters.status.map((s) => s.toLowerCase());
            if (statusValues.includes("active") && !statusValues.includes("inactive")) {
                apiFilters.isActive = true;
            }
            else if (statusValues.includes("inactive") &&
                !statusValues.includes("active")) {
                apiFilters.isActive = false;
            }
        }
        else if (typeof gridFilters.status === "string" &&
            gridFilters.status.trim() !== "") {
            const s = gridFilters.status.toLowerCase();
            if (s === "active") {
                apiFilters.isActive = true;
            }
            else if (s === "inactive") {
                apiFilters.isActive = false;
            }
        }
    }
    return apiFilters;
}
